<template>
  <section v-on:click="sectionClicked" class="catSection"
    :class="{filterOpen: filterOpen}">
    <Header class="scrolled" :category="category" ref="header"/>
    <div class="loadingLanguage" v-if="loadingLang"></div>
    <div v-else>
      <div class="filterToggleMobile" v-on:click="filterOpen = !filterOpen"></div>
      <div class="filterCnt">
        <div class="filterTitle">
          <span>{{lang.langs.filter_label.value}}</span>
          <div class="filterToggle" v-on:click="filterOpen = !filterOpen"></div>
        </div>
        <perfect-scrollbar class="filterSc">
          <div class="filterSection withHeader" :class="{collapsed: filter.status.collapsed}"
            v-on:click="filter.status.collapsed = !filter.status.collapsed">
            <h4 class="withHeader">{{lang.langs.filter_status.value}}</h4>
            <div v-for="(item, i) in filterStatus" :key="i">
              <div class="filterItem header">
                <span v-if="langCode === 'id'">{{item.name}}</span>
                <span v-else-if="langCode === 'en'">{{item.nameEn}}</span>
              </div>
              <div class="filterItem" v-for="(st, i2) in item.status" :key="i2"
                :class="{selected: st.selected}"
                v-on:click.stop="selectFilterStatus(st)">
                <div class="checkbox" :class="{selected: st.selected}"></div>
                <span v-if="langCode === 'id'">{{st.status}}</span>
                <span v-else-if="langCode === 'en'">{{st.statusEn}}</span>
              </div>
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.subjekHukum.collapsed}"
            v-on:click="filter.subjekHukum.collapsed = !filter.subjekHukum.collapsed"
            v-if="1>2">
            <h4>Subjek Hukum</h4>
            <div class="filterItem" v-for="(item, i) in filterSubjekHukum" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="selectFilterSh(item)">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              {{item.name}}
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.category.collapsed}"
            v-on:click="filter.category.collapsed = !filter.category.collapsed">
            <h4>{{lang.langs.filter_category.value}}</h4>
            <div class="filterItem" v-for="(item, i) in filterCategory" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="selectCategory(item)">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              <span v-if="langCode === 'id'">{{item.label}}</span>
              <span v-else-if="langCode === 'en'">{{item.labelEn}}</span>
              <div class="subSection" v-on:click.stop="doNothing"
                v-if="item.subcategories && item.subcategories.length > 0">
                <div class="filterItem" v-for="(item2, i2) in item.subcategories" :key="i2"
                  :class="{selected: item2.selected}"
                  v-on:click.stop="selectCategory(item2)">
                  <div class="checkbox" :class="{selected: item2.selected}"></div>
                  <span v-if="langCode === 'id'">{{item2.label}}</span>
                  <span v-else-if="langCode === 'en'">{{item2.labelEn}}</span>
                  <div class="subSection" v-on:click.stop="doNothing"
                    v-if="item2.subcategories && item2.subcategories.length > 0">
                    <div class="filterItem" v-for="(item3, i3) in item2.subcategories" :key="i3"
                      :class="{selected: item3.selected}"
                      v-on:click.stop="selectCategory(item3)">
                      <div class="checkbox" :class="{selected: item3.selected}"></div>
                      <span v-if="langCode === 'id'">{{item3.label}}</span>
                      <span v-else-if="langCode === 'en'">{{item3.labelEn}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.location.collapsed}"
            v-on:click="filter.location.collapsed = !filter.location.collapsed">
            <h4>{{lang.langs.filter_location.value}}</h4>
            <div class="filterItem" v-for="(item, i) in filterLocation" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="item.selected = !item.selected; filterChanged()">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              <div class="count" v-if="item.count">{{item.count}}</div>
              {{item.label}}
            </div>
            <div class="filterItem viewMore">
              <img src="../assets/link.png">
              Lihat selengkapnya
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.regDate.collapsed}"
            v-on:click="filter.regDate.collapsed = !filter.regDate.collapsed">
            <h4>{{lang.langs.filter_reg_date.value}}</h4>
            <div class="filterDate" v-on:click.stop="doNothing">
              <div class="fdDate">
                <select class="field" v-model="filterRegDate.d"
                  v-on:change="filterChanged">
                  <option value="-">dd</option>
                  <option v-for="i in 31" :key="i">{{i}}</option>
                </select>
              </div>
              <div class="fdMonth">
                <select class="field" v-model="filterRegDate.m"
                  v-on:change="filterChanged">
                  <option value="-">mm</option>
                  <option v-for="(mm, i) in filterMonth" :key="i"
                    :value="i">{{mm}}</option>
                </select>
              </div>
              <div class="fdYear">
                <select class="field" v-model="filterRegDate.y"
                  v-on:change="filterChanged">
                  <option value="-">yyyy</option>
                  <option v-for="(mm, i) in filterYear" :key="i"
                    :value="i">{{mm}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.putusanDate.collapsed}"
            v-on:click="filter.putusanDate.collapsed = !filter.putusanDate.collapsed">
            <h4>{{lang.langs.filter_date.value}}</h4>
            <div class="filterDate" v-on:click.stop="doNothing">
              <div class="fdDate">
                <select class="field" v-model="filterPutusanDate.d"
                  v-on:change="filterChanged">
                  <option value="-">dd</option>
                  <option v-for="i in 31" :key="i">{{i}}</option>
                </select>
              </div>
              <div class="fdMonth">
                <select class="field" v-model="filterPutusanDate.m"
                  v-on:change="filterChanged">
                  <option value="-">mm</option>
                  <option v-for="(mm, i) in filterMonth" :key="i"
                    :value="i">{{mm}}</option>
                </select>
              </div>
              <div class="fdYear">
                <select class="field" v-model="filterPutusanDate.y"
                  v-on:change="filterChanged">
                  <option value="-">yyyy</option>
                  <option v-for="(mm, i) in filterYear" :key="i"
                    :value="i">{{mm}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="filterAction">
            <button class="secondary" v-on:click="cancelFilter">
              {{lang.langs.cancel_button.value}}</button>
            <button v-on:click="filterOpen = true">{{lang.langs.filter_apply.value}}</button>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="itemCnt">
        <div class="itemOk">
          <div class="bcnb">
            <div class="breadcrumb">
              <a href="/" class="bc">Home</a>
              <span class="dv">/</span>
              <a href="/ahli" class="bc">
                <template v-if="langCode === 'id'">Ahli</template>
                <template v-if="langCode === 'en'">Expert</template>
              </a>
              <span class="dv">/</span>
              <span class="bc">{{lang.langs.website_name.value}}</span>
            </div>
          </div>
          <div class="searchCnt">
            <form v-on:submit.prevent="openSearch(q)" v-on:click.stop="doNothing">
              <div class="searchIcon" :class="{searching: searching}"></div>
              <input type="text"
                :placeholder="langCode === 'id' ? 'Cari berdasarkan nama ahli...' : 'Find expert by name...'"
                v-model="q" v-on:input="search" v-on:focus="autocompleteOpen = true">
              <div class="autocomplete"
                v-if="autocomplete.length > 0 && autocompleteOpen">
                <li v-for="(ac, i) in autocomplete" :key="i" class="suggestion"
                  v-on:click="openSearch(ac.namaAhli)">
                  <span>{{ac.namaAhli}}</span>
                  <p v-if="ac.gelarAhli">{{ac.gelarAhli}}</p>
                </li>
              </div>
            </form>
            <div class="sortBy">
              <div class="sortByBtn" v-on:click.stop="showSortOptions = !showSortOptions">
                <div class="sortIcon"></div>
                <span>{{lang.langs.sort_by.value}}: </span>
                <b>{{sortOptions[selectedSort].label}}</b>
              </div>
              <div class="sortByOptions" v-if="showSortOptions"
                v-on:click.stop="doNothing">
                <li v-for="(item, i) in sortOptions" :key="i"
                  v-on:click.stop="selectSort(i)"
                  :class="{selected: selectedSort === i}">
                  {{item.label}}</li>
              </div>
            </div>
          </div>
          <div class="subCategoryCnt" v-if="category
            && category.submenu && category.submenu.length > 0">
            <a :href="`/${item.slug}`"
              class="subCategoryItem" v-for="(item, i) in category.submenu" :key="i">
              <div class="subCategoryImg hasImg" v-if="item.media"
                :style="{'background-image': `url(${item.media.imageMd})`}"></div>
              <div class="subCategoryImg noImg" v-else>
              </div>
              <span v-if="langCode === 'id'">{{item.name}}</span>
              <span v-else-if="langCode === 'en'">{{item.nameEn}}</span>
            </a>
          </div>
          <div class="selectedFilter" v-if="allFilter.length > 0">
            <div class="selectedFilterItem" v-for="(filter, i) in allFilter" :key="i"
              v-on:click="deselectFilter(i, filter)">
              {{filter.label}}
            </div>
            <div class="selectedFilterItem clearFilter"
              v-on:click="resetFilter">{{lang.langs.filter_reset.value}}</div>
          </div>
          <div class="loading" v-if="loading">
            <div class="progress">
              <div class="indeterminate"></div>
            </div>
          </div>
          <div class="notFoundCnt" v-else-if="results.length < 1">
            <div class="notFound">
              <img src="../assets/trash-empty.png">
              <h2>{{lang.langs.no_data_title.value}}</h2>
              <p>{{lang.langs.no_data_desc.value}}</p>
            </div>
          </div>
          <div class="allContentCnt"
            v-if="results && results.length > 0">
            <h2 class="sectionTitle">{{total.toLocaleString('id')}}
              {{lang.langs.case_found.value}}</h2>
            <div class="allContent">
              <div class="contentSc artc">
                <div class="contentCnt">
                  <div class="contentItem" :class="item.type"
                    v-on:click="openItem(item, i)"
                    v-for="(item, i) in results" :key="i">
                    <h4 v-on:click.stop="doNothing">
                      <router-link :to="`/${item.category.slug}/${item.slug}?u=${uuid}`">
                        <span v-if="langCode === 'id'">{{item.title}}</span>
                        <span v-else-if="langCode === 'en'">{{item.titleEn}}</span>
                      </router-link>
                    </h4>
                    <div class="labels">
                      <div class="label category" v-if="item.categories
                        && item.categories.length > 0">
                        <span v-if="item.categories[0].parent">
                          <template v-if="langCode === 'id'">
                            {{item.categories[0].parent.name}}</template>
                          <template v-else-if="langCode === 'en'">
                            {{item.categories[0].parent.nameEn}}</template>
                          /
                        </span>
                        <template v-if="langCode === 'id'">
                          {{item.categories[0].name}}</template>
                        <template v-else-if="langCode === 'en'">
                          {{item.categories[0].nameEn}}</template>
                        <span v-if="item.categories.length > 1">
                          + {{item.categories.length - 1}} more
                        </span>
                      </div>
                      <div class="label status" v-if="item.statusPutusan">
                        <span v-if="langCode === 'id'">{{item.statusPutusan.status}}</span>
                        <span v-else-if="langCode === 'en'">{{item.statusPutusan.statusEn}}</span>
                      </div>
                      <div class="label subjekHukum" v-if="item.subjekHukum">
                        {{item.subjekHukum.name}}
                      </div>
                      <div class="label location" v-if="item.province">
                        {{item.province.name}}
                      </div>
                    </div>
                    <div class="contentInfo">
                      <div class="contentInfoL">
                        <div class="contentDesc" v-on:click.stop="doNothing">
                          <router-link :to="`/${item.category.slug}/${item.slug}?u=${uuid}`">
                            <template v-if="langCode === 'id'">{{item.sinopsis}}</template>
                            <template v-else-if="langCode === 'en'">{{item.sinopsisEn}}</template>
                          </router-link>
                        </div>
                        <template v-if="langCode === 'id'">
                          <div class="tags" v-if="item.tags && item.tags.length > 0">
                            <div class="tag" v-for="(tag, iTag) in item.tags" :key="iTag"
                              v-on:click.stop="tagClicked(tag)">
                              {{tag}}</div>
                          </div>
                        </template>
                        <template v-else-if="langCode === 'en'">
                          <div class="tags" v-if="item.tagsEn && item.tagsEn.length > 0">
                            <div class="tag" v-for="(tag, iTag) in item.tagsEn" :key="iTag"
                              v-on:click.stop="tagClicked(tag)">
                              {{tag}}</div>
                          </div>
                        </template>
                      </div>
                      <div class="dateCnt">
                        <div class="theDate">
                          <div class="date">
                            <div class="dateLabel">{{lang.langs.reg_date_label.value}}</div>
                            <span v-if="item.tanggalDaftar">:
                              {{item.tanggalDaftar | moment('DD/MM/YYYY')}}</span>
                            <span v-else>: -</span>
                          </div>
                          <div class="date">
                            <div class="dateLabel">{{lang.langs.date_label.value}}</div>
                            <span v-if="item.tanggalPutusan">:
                              {{item.tanggalPutusan | moment('DD/MM/YYYY')}}</span>
                            <span v-else>: -</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="loadMoreCnt" v-if="canLoadMore && !loadingMore"
              v-on:click="loadMore">
              <div class="loadMore">{{lang.langs.load_more.value}}</div>
            </div>
            <div class="loadingMore" v-if="loadingMore && canLoadMore">
              <div class="loadingImg"></div>
              {{lang.langs.loading_more.value}}
            </div>
            <div class="copyright">
              &copy; 2022 Indonesian Center for Environmental Law (ICEL)
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: true,
      results: [],
      category: null,
      allYear: [],
      year: null,
      currentYear: 0,
      city: '',
      country: '',
      inPage: true,
      singingAl: true,
      uuid: '',
      minYear: 2021,
      loadingMore: false,
      canLoadMore: true,
      page: 0,
      total: 0,
      parentSlug: '',
      loadingStatus: true,

      /**
       * Search and sorting
       *
       */
      q: '',
      searchTimer: null,
      showSortOptions: false,
      selectedSort: 0,
      sortOptions: [
        { value: 'lastUpload', label: 'Putusan Terbaru' },
        { value: 'putusanDesc', label: 'Tanggal Putusan Terbaru' },
        { value: 'regDesc', label: 'Tanggal Registrasi Terbaru' },
        { value: 'putusanAsc', label: 'Tanggal Putusan Terakhir' },
        { value: 'regAsc', label: 'Tanggal Registrasi Terakhir' },
      ],

      /**
       * Filter
       *
       */
      filterOpen: true,
      allFilter: [],
      filter: {
        status: { collapsed: false },
        subjekHukum: { collapsed: true },
        location: { collapsed: true },
        regDate: { collapsed: true },
        putusanDate: { collapsed: true },
        category: { collapsed: true },
      },
      filterStatus: [],
      filterSubjekHukum: [],
      filterLocation: [],
      filterMonth: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      filterYear: [],
      filterRegDate: { d: '-', m: '-', y: '-' },
      filterPutusanDate: { d: '-', m: '-', y: '-' },
      filterCategory: [],

      /**
       * Language
       *
       */
      loadingLang: true,
      langCode: 'id',
      lang: null,

      searching: false,
      autocomplete: [],
      autocompleteOpen: false,
    };
  },
  methods: {
    doNothing() {},
    selectCategory(item) {
      // eslint-disable-next-line
      item.selected = !item.selected;
      this.filterChanged();
    },
    selectFilterStatus(item) {
      // eslint-disable-next-line
      item.selected = !item.selected;
      this.filterChanged();
    },
    selectFilterSh(item) {
      // eslint-disable-next-line
      item.selected = !item.selected;
      this.filterChanged();
    },
    openItem(item, i) {
      this.$router.push(`/${item.category.slug}/${item.slug}`);
    },
    tagClicked(tag) {
      const tagEncoded = encodeURI(tag.replaceAll('#', ''));
      window.location.href = `/${this.parentSlug}?hashtags=${tagEncoded}`;
    },
    search() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searching = true;
        this.autocompleteOpen = true;
        this.$http.get(this.$config.uri(`content/all-ahli/autocomplete?q=${this.q}`)).then((r) => {
          this.searching = false;
          this.autocomplete = (r.data.status === 200) ? r.data.data : [];
        });
      }, 500);
    },
    openSearch(q) {
      this.q = q;
      this.autocompleteOpen = false;
      this.getData();
    },
    sectionClicked() {
      this.showSortOptions = false;
      this.autocompleteOpen = false;
      this.$refs.header.sectionClicked();
    },
    selectSort(i) {
      this.selectedSort = i;
      this.showSortOptions = false;
      this.getData();
    },
    signAnalytic() {
      if (!this.inPage) {
        this.singingAl = false;
        return;
      }
      this.singingAl = true;
      const alUri = `misc/al/home/${this.category.id}?session=${this.sessionId}&uuid=${this.uuid}`;
      this.$http.post(this.$config.uri(alUri), {
        city: this.city,
        country: this.country,
      }).then((r) => {
        setTimeout(() => {
          this.singingAl = false;
          this.signAnalytic();
        }, 5000);
      });
    },
    windowFocused() {
      this.inPage = true;
      if (!this.singingAl) this.signAnalytic();
    },
    windowBlured() {
      this.inPage = false;
    },
    resetFilter() {
      this.allFilter = [];
      // eslint-disable-next-line
      for (const item of this.filterStatus) {
        // eslint-disable-next-line
        for (const st of item.status) {
          st.selected = false;
        }
      }
      // eslint-disable-next-line
      for (const item of this.filterSubjekHukum) {
        item.selected = false;
      }
      // eslint-disable-next-line
      for (const item of this.filterCategory) {
        item.selected = false;
        if (item.subcategories && item.subcategories.length > 0) {
          // eslint-disable-next-line
          for (const item2 of item.subcategories) {
            item2.selected = false;
            if (item2.subcategories && item2.subcategories.length > 0) {
              // eslint-disable-next-line
              for (const item3 of item2.subcategories) {
                item3.selected = false;
              }
            }
          }
        }
      }
      // eslint-disable-next-line
      for (const item of this.filterLocation) {
        item.selected = false;
      }

      this.filterRegDate.y = '-';
      this.filterRegDate.m = '-';
      this.filterRegDate.d = '-';

      this.filterPutusanDate.y = '-';
      this.filterPutusanDate.m = '-';
      this.filterPutusanDate.d = '-';

      const url = new URL(window.location);
      url.searchParams.set('st', '');
      url.searchParams.set('ctr', '');
      url.searchParams.set('loc', '');
      url.searchParams.set('tr', '');
      url.searchParams.set('tp', '');
      window.history.replaceState(null, null, url);

      this.getData();
    },
    deselectFilter(i, filter) {
      if (filter.type === 'status') {
        // eslint-disable-next-line
        for (const item of this.filterStatus) {
          // eslint-disable-next-line
          for (const st of item.status) {
            if (st.id === filter.value && st.selected) {
              st.selected = false;
            }
          }
        }
      } else if (filter.type === 'subjekHukum') {
        // eslint-disable-next-line
        for (const item of this.filterSubjekHukum) {
          if (item.id === filter.value && item.selected) {
            item.selected = false;
          }
        }
      } else if (filter.type === 'category') {
        // eslint-disable-next-line
        for (const item of this.filterCategory) {
          if (item.value === filter.value && item.selected) {
            item.selected = false;
          }
          if (item.subcategories && item.subcategories.length > 0) {
            // eslint-disable-next-line
            for (const item2 of item.subcategories) {
              if (item2.value === filter.value && item2.selected) {
                item2.selected = false;
              }
              if (item2.subcategories && item2.subcategories.length > 0) {
                // eslint-disable-next-line
                for (const item3 of item2.subcategories) {
                  if (item3.value === filter.value && item3.selected) {
                    item3.selected = false;
                  }
                }
              }
            }
          }
        }
      } else if (filter.type === 'location') {
        // eslint-disable-next-line
        for (const item of this.filterLocation) {
          if (item.value === filter.value && item.selected) {
            item.selected = false;
          }
        }
      } else if (filter.type === 'tanggalRegistrasi') {
        this.filterRegDate.y = '-';
        this.filterRegDate.m = '-';
        this.filterRegDate.d = '-';
      } else if (filter.type === 'tanggalPutusan') {
        this.filterPutusanDate.y = '-';
        this.filterPutusanDate.m = '-';
        this.filterPutusanDate.d = '-';
      }

      this.filterChanged();
    },
    cancelFilter() {
      this.resetFilter();
      this.filterOpen = true;
    },
    filterChanged() {
      this.allFilter = [];
      const statusQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterStatus) {
        // eslint-disable-next-line
        for (const st of item.status) {
          if (st.selected) {
            const label = (this.langCode === 'id') ? st.status : st.statusEn;
            statusQuery.push(st.id);
            this.allFilter.push({
              type: 'status',
              value: st.id,
              label: `${this.lang.langs.filter_status.value}: ${label}`,
            });
          }
        }
      }

      const shQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterSubjekHukum) {
        if (item.selected) {
          const label = (this.langCode === 'id') ? item.name : item.nameEn;
          shQuery.push(item.id);
          this.allFilter.push({
            type: 'subjekHukum',
            value: item.id,
            label: `Subjek Hukum: ${label}`,
          });
        }
      }

      const catQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterCategory) {
        if (item.selected) {
          const label = (this.langCode === 'id') ? item.label : item.labelEn;
          catQuery.push(item.value);
          this.allFilter.push({
            type: 'category',
            value: item.value,
            label: `${this.lang.langs.filter_category.value}: ${label}`,
          });
        }
        if (item.subcategories && item.subcategories.length > 0) {
          // eslint-disable-next-line
          for (const item2 of item.subcategories) {
            if (item2.selected) {
              const label = (this.langCode === 'id') ? item2.label : item2.labelEn;
              catQuery.push(item2.value);
              this.allFilter.push({
                type: 'category',
                value: item2.value,
                label: `${this.lang.langs.filter_category.value}: ${label}`,
              });
            }
            if (item2.subcategories && item2.subcategories.length > 0) {
              // eslint-disable-next-line
              for (const item3 of item2.subcategories) {
                if (item3.selected) {
                  const label = (this.langCode === 'id') ? item3.label : item3.labelEn;
                  catQuery.push(item3.value);
                  this.allFilter.push({
                    type: 'category',
                    value: item3.value,
                    label: `${this.lang.langs.filter_category.value}: ${label}`,
                  });
                }
              }
            }
          }
        }
      }
      const locationQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterLocation) {
        if (item.selected) {
          locationQuery.push(item.value);
          this.allFilter.push({
            type: 'location',
            value: item.value,
            label: `${this.lang.langs.filter_location.value}: ${item.label}`,
          });
        }
      }

      let tanggalRegistrasi = '';
      const regY = (this.filterRegDate.y !== '-')
        ? this.filterYear[this.filterRegDate.y]
        : '-';
      let regM = (this.filterRegDate.m !== '-') ? this.filterRegDate.m + 1 : '-';
      if (regM !== '-' && parseInt(regM, 10) < 10) regM = `0${regM}`;
      let regD = this.filterRegDate.d || '-';
      if (regD !== '-' && parseInt(regD, 10) < 10) regD = `0${regD}`;
      if (regY !== '-' || regM !== '-' || regD !== '-') {
        tanggalRegistrasi = `${regY}/${regM}/${regD}`;
        this.allFilter.push({
          type: 'tanggalRegistrasi',
          value: tanggalRegistrasi,
          label: `${this.lang.langs.filter_reg_date.value}: ${regD}/${regM}/${regY}`,
        });
      }

      let tanggalPutusan = '';
      const putusanY = (this.filterPutusanDate.y !== '-')
        ? this.filterYear[this.filterPutusanDate.y]
        : '-';
      let putusanM = (this.filterPutusanDate.m !== '-')
        ? this.filterPutusanDate.m + 1 : '-';
      if (putusanM !== '-' && parseInt(putusanM, 10) < 10) putusanM = `0${putusanM}`;
      let putusanD = this.filterPutusanDate.d || '-';
      if (putusanD !== '-' && parseInt(putusanD, 10) < 10) putusanD = `0${putusanD}`;
      if (putusanY !== '-' || putusanM !== '-' || putusanD !== '-') {
        tanggalPutusan = `${putusanY}/${putusanM}/${putusanD}`;
        this.allFilter.push({
          type: 'tanggalPutusan',
          value: tanggalPutusan,
          label: `${this.lang.langs.filter_date.value}: ${putusanD}/${putusanM}/${putusanY}`,
        });
      }

      const catQueryStr = catQuery.join(';');
      const locationQueryStr = locationQuery.join(';');
      const statusQueryStr = statusQuery.join(';');
      const shQueryStr = shQuery.join(';');
      const url = new URL(window.location);
      url.searchParams.set('st', statusQueryStr);
      url.searchParams.set('sh', shQueryStr);
      url.searchParams.set('ctr', catQueryStr);
      url.searchParams.set('loc', locationQueryStr);
      url.searchParams.set('tr', tanggalRegistrasi);
      url.searchParams.set('tp', tanggalPutusan);
      window.history.replaceState(null, null, url);

      this.getData();
    },
    getData() {
      this.loading = true;
      // const { parent } = this.$route.params;
      const parent = 'portal-putusan-icel';
      const year = (this.$route.params.year && this.$route.params.year !== 'all')
        ? `&year=${this.$route.params.year}` : '';
      if (parent) {
        this.uuid = this.$route.query.u || '';
        this.$http.get(this.$config.uri(`content/parent/${parent}?session=${this.sessionId}`)).then((r) => {
          this.category = (r.data.status === 200) ? r.data.data : null;
          if (r.data.status !== 200) this.loading = false;
          document.title = `${this.category.name} - ${this.$config.appName}`;
          this.sessionId = r.data.session;
          const uri = `content/all?parentId=${this.category.id}${year}&limit=12&lang=${this.langCode}`;
          this.$http.post(this.$config.uri(uri), {
            sort: this.sortOptions[this.selectedSort].value,
            filter: this.allFilter,
            ahli: this.q,
          }).then((rr) => {
            this.results = (rr.data.status === 200) ? rr.data.data : [];
            this.total = (rr.data.status === 200) ? rr.data.total : 0;
            this.loading = false;
            this.canLoadMore = (this.results.length >= 12);
          });
          this.city = localStorage.getItem('city');
          this.country = localStorage.getItem('country');
          if (!this.city || this.city === 'null') {
            this.$http.get('https://ipinfo.io?token=c698cbf39a7613').then((rrr) => {
              this.city = rrr.data.city;
              this.country = rrr.data.country;
              localStorage.setItem('city', this.city);
              localStorage.setItem('country', this.country);
              this.signAnalytic();
            });
          } else {
            this.signAnalytic();
          }
        });
      } else {
        const { uuid } = this.$route.params;
        this.uuid = uuid;
        this.$http.get(this.$config.uri(`content/uuid/${uuid}`)).then((r) => {
          if (r.data.status === 200 && r.data.data.length === 1) {
            const [item] = r.data.data;
            this.$router.push(`/${item.category.slug}/${item.slug}?u=${uuid}`);
            return;
          }
          this.loading = false;
          this.results = (r.data.status === 200) ? r.data.data : [];
          this.category = (r.data.status === 200) ? { slug: `p/${uuid}`, name: 'Contents' } : null;
        });
      }
    },
    loadMore() {
      const { parent } = this.$route.params;
      if (!this.category) {
        this.loadingMore = false;
        return;
      }
      const year = (this.$route.params.year && this.$route.params.year !== 'all')
        ? `&year=${this.$route.params.year}` : '';
      this.page += 1;
      this.$http.post(this.$config.uri(`content/all?parentId=${this.category.id}${year}&limit=12&page=${this.page}`), {
        filter: this.allFilter,
      }).then((rr) => {
        this.loadingMore = false;
        if (rr.data.status !== 200) {
          this.canLoadMore = false;
          return;
        }
        this.results.push(...rr.data.data);
      });
    },
    getCategories() {
      this.$http.get(this.$config.uri('content/status/all')).then((rst) => {
        this.loadingStatus = false;
        this.filterStatus = (rst.data.status === 200) ? rst.data.data : [];
        this.$http.get(this.$config.uri('content/subjek-hukum/all')).then((rsh) => {
          this.filterSubjekHukum = (rsh.data.status === 200) ? rsh.data.data : [];
          this.$http.get(this.$config.uri('category/all/filter')).then((rc) => {
            this.filterCategory = (rc.data.status === 200) ? rc.data.data : [];
            if (this.$route.query.ctr && this.$route.query.ctr !== '') {
              const ctr = decodeURIComponent(this.$route.query.ctr);
              const ctrs = ctr.split(';');
              // eslint-disable-next-line
              for (const item of ctrs) {
                // eslint-disable-next-line
                for (const c of this.filterCategory) {
                  if (c.value === parseInt(item, 10)) {
                    // eslint-disable-next-line
                    c.selected = true;
                    this.allFilter.push({
                      type: 'category',
                      value: c.value,
                      label: `${this.lang.langs.filter_category.value}: ${c.label}`,
                    });
                  }
                  if (c.subcategories && c.subcategories.length > 0) {
                    // eslint-disable-next-line
                    for (const c2 of c.subcategories) {
                      if (c2.value === parseInt(item, 10)) {
                        // eslint-disable-next-line
                        c2.selected = true;
                        this.allFilter.push({
                          type: 'category',
                          value: c2.value,
                          label: `${this.lang.langs.filter_category.value}: ${c2.label}`,
                        });
                      }
                      if (c2.subcategories && c2.subcategories.length > 0) {
                        // eslint-disable-next-line
                        for (const c3 of c2.subcategories) {
                          if (c3.value === parseInt(item, 10)) {
                            // eslint-disable-next-line
                            c3.selected = true;
                            this.allFilter.push({
                              type: 'category',
                              value: c3.value,
                              label: `${this.lang.langs.filter_category.value}: ${c3.label}`,
                            });
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            this.$http.get(this.$config.uri('misc/province/filter')).then((rpv) => {
              this.filterLocation = (rpv.data.status === 200) ? rpv.data.data : [];
              if (this.$route.query.loc && this.$route.query.loc !== '') {
                const loc = decodeURIComponent(this.$route.query.loc);
                const locs = loc.split(';');
                // eslint-disable-next-line
                for (const item of locs) {
                  // eslint-disable-next-line
                  for (const c of this.filterLocation) {
                    if (c.value === parseInt(item, 10)) {
                      // eslint-disable-next-line
                      c.selected = true;
                      this.allFilter.push({
                        type: 'location',
                        value: c.value,
                        label: `${this.lang.langs.filter_location.value}: ${c.label}`,
                      });
                    }
                  }
                }
              }

              if (this.$route.query.st && this.$route.query.st !== '') {
                const st = decodeURIComponent(this.$route.query.st);
                const sts = st.split(';');
                // eslint-disable-next-line
                for (const item of sts) {
                  // eslint-disable-next-line
                  for (const c of this.filterStatus) {
                    // eslint-disable-next-line
                    for (const st of c.status) {
                      if (st.id === parseInt(item, 10)) {
                        // eslint-disable-next-line
                        st.selected = true;
                        this.allFilter.push({
                          type: 'status',
                          value: st.id,
                          label: `${this.lang.langs.filter_status.value}: ${st.status}`,
                        });
                      }
                    }
                  }
                }
              }

              if (this.$route.query.sh && this.$route.query.sh !== '') {
                const st = decodeURIComponent(this.$route.query.sh);
                const sts = st.split(';');
                // eslint-disable-next-line
                for (const item of sts) {
                  // eslint-disable-next-line
                  for (const c of this.filterSubjekHukum) {
                    if (c.id === parseInt(item, 10)) {
                      // eslint-disable-next-line
                      c.selected = true;
                      this.allFilter.push({
                        type: 'subjekHukum',
                        value: c.id,
                        label: `Subjek Hukum: ${c.name}`,
                      });
                    }
                  }
                }
              }

              if (this.$route.query.tr && this.$route.query.tr !== '') {
                const tr = decodeURIComponent(this.$route.query.tr);
                const trs = tr.split('/');
                if (trs[0] !== '-') {
                  let iy = 0;
                  // eslint-disable-next-line
                  for (const item of this.filterYear) {
                    if (item === parseInt(trs[0], 10)) this.filterRegDate.y = iy;
                    iy += 1;
                  }
                }
                if (trs[1] !== '-') this.filterRegDate.m = parseInt(trs[1], 10) - 1;
                if (trs[2] !== '-') this.filterRegDate.d = parseInt(trs[2], 10);
                this.allFilter.push({
                  type: 'tanggalRegistrasi',
                  value: tr,
                  label: `${this.lang.langs.filter_reg_date.value}: ${trs[2]}/${trs[1]}/${trs[0]}`,
                });
              }

              if (this.$route.query.tp && this.$route.query.tp !== '') {
                const tp = decodeURIComponent(this.$route.query.tp);
                const tps = tp.split('/');
                if (tps[0] !== '-') {
                  let iy = 0;
                  // eslint-disable-next-line
                  for (const item of this.filterYear) {
                    if (item === parseInt(tps[0], 10)) this.filterPutusanDate.y = iy;
                    iy += 1;
                  }
                }
                if (tps[1] !== '-') this.filterPutusanDate.m = parseInt(tps[1], 10) - 1;
                if (tps[2] !== '-') this.filterPutusanDate.d = parseInt(tps[2], 10);
                this.allFilter.push({
                  type: 'tanggalPutusan',
                  value: tp,
                  label: `${this.lang.langs.filter_date.value}: ${tps[2]}/${tps[1]}/${tps[0]}`,
                });
              }

              this.getData();
            });
          });
        });
      });
    },
    windowScrolled() {
      // const reachBot = document.documentElement.scrollTop + window.innerHeight
      //   >= document.documentElement.offsetHeight -
      // (document.getElementById('footer').clientHeight
      //   + 400);
      // if (reachBot && !this.loadingMore && this.canLoadMore) {
      //   this.loadingMore = true;
      //   this.loadMore();
      // }
    },
  },
  created() {
    window.addEventListener('focus', this.windowFocused);
    window.addEventListener('blur', this.windowBlured);
    window.addEventListener('scroll', this.windowScrolled);
  },
  destroyed() {
    window.removeEventListener('focus', this.windowFocused);
    window.removeEventListener('blur', this.windowBlured);
    window.removeEventListener('scroll', this.windowScrolled);
  },
  beforeDestroy() {
    this.inPage = false;
  },
  mounted() {
    this.inPage = true;
    document.title = this.$config.appName;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.sessionId = sessionStorage.getItem('sessionId');

    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';

    this.$http.get(this.$config.uri(`misc/lang/${this.langCode}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;

      this.sortOptions[0].label = this.lang.langs.sort_latest.value;
      this.sortOptions[1].label = this.lang.langs.sort_date_latest.value;
      this.sortOptions[2].label = this.lang.langs.sort_reg_date_latest.value;
      this.sortOptions[3].label = this.lang.langs.sort_date_oldest.value;
      this.sortOptions[4].label = this.lang.langs.sort_reg_date_oldest.value;

      this.parentSlug = 'portal-putusan-icel';

      this.q = this.$route.params.name;
      this.getCategories();

      /**
       * Filter
       *
       */
      const d = new Date();
      for (let i = d.getFullYear(); i > 1800; i -= 1) {
        this.filterYear.push(i);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.catSection{
  min-height: calc(100vh - 60px);
}

.selectedFilter{
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px 16px;
  .selectedFilterItem{
    padding: 5px 10px 4px;
    border-radius: 3px;
    border: #a7cbf2 1px solid;
    color: #012f5f;
    background-color: #f0f7ff;
    margin: 0 6px 6px 0;
    font-size: 12px;
    padding-right: 26px;
    position: relative;
    cursor: pointer;
    transition: all .3s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
    &:hover{
      border-color: #6d94bf;
      background-color: #e2f1ff;
    }
    &:before{
      content: "";
      position: absolute;
      right: 6px; top: 5px;
      width: 15px; height: 15px;
      border-radius: 50%;
      background-color: #a7cbf2;
      background-image: url(../assets/close.png);
      background-size: 6px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &.clearFilter{
      background-color: #fff;
      border-color: #fff;
      cursor: pointer;
      // font-weight: 600;
      transition: all .3s ease;
      padding-right: 10px;
      &:before{
        display: none;
      }
      &:hover{
        background-color: #002f5f;
        color: #fff;
      }
    }
  }
}

.filterToggleMobile{
  position: fixed;
  left: 20px; bottom: 30px;
  z-index: 97;
  width: 60px; height: 60px;
  background-color: #369d66;
  background-image: url(../assets/filter-white.png);
  background-size: 22px auto;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  cursor: pointer;
  transition: all .3s ease;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .3);
  display: none;
  @media (max-width: 680px) {
    display: block;
  }
}
.filterCnt{
  position: fixed;
  top: 60px; left: 0; bottom: 0;
  width: 50px;
  border-right: #eee 1px solid;
  background-color: #fff;
  z-index: 97;
  @media (max-width: 1140px) {
    transition: all .3s ease;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    width: 300px;
  }
  .filterSc{
    position: absolute;
    top: 49px; left: 0; right: 0; bottom: 0;
    overflow-y: auto;
    padding-bottom: 20px;
    display: none;
    @media (max-width: 1140px) {
      transition: all .3s ease;
      display: block;
      opacity: 1;
    }
  }
  .filterTitle{
    font-size: 20px;
    border-bottom: #eee 1px solid;
    font-weight: 400;
    position: relative;
    height: 50px;
    box-sizing: border-box;
    @media (max-width: 1140px) {
      padding: 14px 20px 8px;
    }
    span{
      display: none;
      @media (max-width: 1140px) {
        display: inline-block;
      }
    }
    .filterToggle{
      position: absolute;
      right: 10px; top: 10px;
      width: 30px; height: 30px;
      background-image: url(../assets/arrow-right.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      cursor: pointer;
      transition: all .3s ease;
      @media (max-width: 1140px) {
        background-image: url(../assets/arrow-left.png);
      }
      &:hover{
        background-color: #eee;
      }
    }
  }
  .filterSection{
    padding: 10px 20px 20px;
    border-bottom: #eee 1px solid;
    margin: 10px 0 0;
    position: relative;
    cursor: pointer;
    &.withHeader{
      padding-bottom: 30px;
    }
    &:before{
      content: "";
      position: absolute;
      width: 30px; height: 30px;
      border-radius: 50%;
      right: 10px; top: 5px;
      background-image: url(../assets/up-arrow.png);
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      // background-color: red;
    }
    &:hover{
      &:before{
        background-color: #eee;
      }
    }
    h4{
      font-size: 17px;
      font-weight: 400;
      margin: 0 0 10px;
      &.withHeader{
        margin-bottom: 0;
      }
    }
    .filterDate{
      display: flex;
      padding: 6px 0;
      .field{
        padding: 8px 6px;
        font-size: 14px;
        text-align: center;
      }
      .fdDate{
        width: 25%;
      }
      .fdMonth{
        width: calc(35% - 16px);
        margin: 0 auto;
      }
      .fdYear{
        width: 40%;
      }
    }
    .filterItem{
      position: relative;
      padding: 6px 0;
      padding-left: 30px;
      font-size: 15px;
      color: #444;
      // font-family: 'Inter', sans-serif;
      font-weight: 500;
      .count{
        float: right;
        color: #767676;
        font-size: 12px;
        padding-top: 2px;
        width: 20px; height: 20px;
        background-color: #f5f5f5;
        text-align: center;
        box-sizing: border-box;
        border-radius: 50%;
      }
      &.header{
        cursor: default;
        text-transform: uppercase;
        padding: 14px 0 4px;
        font-size: 13px;
        color: #767676 !important;
        // font-family: 'Inter', sans-serif;
        font-weight: 600;
      }
      &.viewMore{
        color: #115457;
        padding-left: 0;
        margin-top: 2px;
        font-size: 14px;
        display: none;
        img{
          height: 13px;
          margin: 2px 8px -2px 0;
          float: left;
        }
        &:hover{
          color: #369d66;
        }
      }
      .checkbox{
        width: 16px; height: 16px;
        position: absolute;
        left: 0; top: 6px;
        border: #999 2px solid;
        border-radius: 3px;
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        &.selected{
          background-color: #369d66;
          border-color: #369d66;
          background-image: url(../assets/checked.png);
        }
      }
      &:hover{
        color: #369d66;
        .checkbox{
          // border-color: #222;
        }
      }
      .subSection{
        margin: 10px 0 10px -21px;
        padding-left: 20px;
        border-left: #ccc 1px solid;
      }
    }
    &.collapsed{
      &:before{
        transform: rotate(180deg);
      }
      .filterDate{
        display: none;
      }
      .filterItem{
        display: none;
      }
    }
  }
  .filterAction{
    text-align: right;
    padding: 10px 20px;
    border-top: #eee 1px solid;
    display: none;
    @media (max-width: 680px) {
      display: block;
    }
    button{
      margin-left: 10px;
    }
  }
}
.itemCnt{
  margin-left: 50px;
  margin-top: 60px;
  @media (max-width: 680px) {
    margin-left: 0;
    padding-bottom: 60px;
  }
  .itemOk{
    margin: 0 auto;
    max-width: 1480px;
  }
}
.filterOpen{
  .filterCnt{
    width: 300px;
    @media (max-width: 1140px) {
      left: -250px;
      box-shadow: none;
    }
    @media (max-width: 680px) {
      left: -300px;
    }
    .filterTitle{
      padding: 14px 20px 8px;
      padding-left: 46px;
      @media (max-width: 680px) {
        padding-left: 0;
      }
      &:before{
        position: absolute;
        top: 5px; bottom: 0; left: 20px;
        width: 17px;
        content: ""; display: block;
        background-image: url(../assets/filter.png);
        background-size: 17px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 680px) {
          display: none;
        }
      }
      span{
        display: inline-block;
      }
      .filterToggle{
        background-image: url(../assets/arrow-left.png);
        @media (max-width: 1140px) {
          background-image: url(../assets/filter.png);
        }
      }
    }
    .filterSc{
      display: block;
      @media (max-width: 1140px) {
        opacity: 0;
      }
    }
  }
  .itemCnt{
    margin-left: 300px;
    @media (max-width: 1140px) {
      margin-left: 50px;
    }
    @media (max-width: 680px) {
      margin-left: 0;
    }
  }
}

.searchCnt{
  padding: 0 20px 20px;
  display: flex;
  @media (max-width: 680px) {
    padding: 0 16px 20px;
  }
  form{
    position: relative;
    width: calc(100% - 380px);
    @media (max-width: 1260px) {
      width: calc(100% - 260px);
    }
    @media (max-width: 760px) {
      width: calc(100% - 50px);
    }
    @media (max-width: 680px) {
    }
    .searchIcon{
      position: absolute;
      left: 10px; top: 0; bottom: 2px;
      z-index: 3; width: 30px;
      background-image: url(../assets/search.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      &.searching{
        background-image: url(../assets/loading.svg);
        background-size: 24px auto;
      }
    }
    input{
      padding: 14px 14px;
      width: 100%;
      border-radius: 5px;
      box-sizing: border-box;
      border: #ccc 1px solid;
      padding-left: 46px;
      // font-family: 'Source Serif Pro', serif;
      font-weight: 400;
      font-size: 16px;
      background-color: #fff;
      &:hover{
        border-color: #222;
      }
    }
    .autocomplete{
      position: absolute;
      left: 0; right: 0; top: 100%;
      background-color: #fff;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
      border-radius: 5px;
      padding: 10px 0;
      z-index: 99;
      li{
        list-style: none;
        // font-family: 'Source Serif Pro', serif;
        font-weight: 400;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 10px 20px;
        padding-left: 46px;
        cursor: pointer;
        position: relative;
        text-align: left;
        &:before{
          content: "";
          position: absolute;
          left: 10px; top: 5px; height: 30px;
          z-index: 3; width: 30px;
          background-image: url(../assets/search.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .3;
        }
        &.suggestion{
          &:before{
            background-image: url(../assets/link.png);
          }
        }
        p{
          margin: 1px 0 0;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #767676;
          max-width: 80%;
        }
        &:hover{
          background-color: #f5f5fe;
        }
      }
    }
  }
  .sortBy{
    width: 380px;
    box-sizing: border-box;
    padding-left: 20px;
    position: relative;
    // font-family: 'Source Serif Pro', serif;
    font-weight: 300;
    @media (max-width: 1260px) {
      width: 260px;
    }
    @media (max-width: 760px) {
      width: 70px;
    }
    @media (max-width: 680px) {
      width: 66px;
      padding-left: 16px;
    }
    b{
      font-weight: 400;
    }
    .sortByBtn{
      border: #ccc 1px solid;
      border-radius: 5px;
      height: 100%;
      padding: 15px 16px 0;
      padding-right: 44px;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      text-overflow: ellipsis;
      cursor: pointer;
      padding-left: 46px;
      position: relative;
      &:hover{
        border-color: #222;
      }
      @media (max-width: 760px) {
        padding: 0;
        width: 50px;
      }
      span{
        @media (max-width: 1260px) {
          display: none;
        }
      }
      b{
        @media (max-width: 760px) {
          display: none;
        }
      }
      .sortIcon{
        position: absolute;
        left: 16px; top: 0; bottom: 2px;
        width: 20px;
        background-image: url(../assets/sort.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:before{
        content: "";
        position: absolute;
        right: 16px; top: 0; bottom: 0; width: 14px;
        opacity: .65;
        background-image: url(../assets/down-arrow.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 760px) {
          display: none;
        }
      }
    }
    .sortByOptions{
      position: absolute;
      right: 0; top: 100%;
      background-color: #fff;
      padding: 10px 0;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      border-radius: 5px;
      border: #eee 1px solid;
      z-index: 9;
      li{
        list-style: none;
        padding: 10px 24px;
        cursor: pointer;
        transition: all .3s ease;
        font-weight: 400;
        white-space: nowrap;
        &:hover{
          background-color: #f5f5fe;
        }
        &.selected{
          background-color: #eee;
        }
      }
    }
  }
}

.loadMoreCnt{
  text-align: center;
  .loadMore{
    display: inline-block;
    border-radius: 5px;
    position: relative;
    font-size: 15px;
    padding: 8px 16px;
    padding-left: 38px;
    transition: all .3s ease;
    border: #fff 1px solid;
    cursor: pointer;
    &:hover{
      border: #eee 1px solid;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    }
    &:before{
      content: "";
      position: absolute;
      left: 12px; top: 7px;
      width: 20px; height: 20px;
      background-image: url(../assets/arrow-down.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
.loadingMore{
  text-align: center;
  padding: 20px 0 26px;
  color: #767676;
  font-size: 15px;
  .loadingImg{
    height: 36px;
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-size: 36px auto;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
}

.prevEdition{
  text-align: center;
  margin-bottom: 40px;
  @media (max-width: 680px) {
    margin-bottom: 20px;
  }
  a{
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    background-color: #002f5f;
    display: inline-block;
    padding: 8px 16px;
    border-radius: 3px;
    border: #002f5f 2px solid;
    transition: all .3s ease;
    &:hover{
      color: #002f5f;
      background-color: #fff;
    }
  }
  &.editionChange{
    display: flex;
    margin: 0 auto 40px;
    max-width: 1180px;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px 30px;
    }
    @media (max-width: 680px) {
      margin: 0 16px 20px;
    }
    a{
      color: #002f5f;
      background-color: #fff;
      border-width: 1px;
      display: inline-block;
      position: relative;
      &:before{
        width: 20px;
        left: 10px; top: 0; bottom: 0;
        position: absolute;
        content: "";
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:hover{
        color: #fff;
        background-color: #002f5f;
      }
      @media (max-width: 680px) {
        span{
          display: none;
        }
      }
    }
    .prev{
      margin-right: auto;
      padding-left: 40px;
      @media (max-width: 680px) {
        padding-left: 36px;
      }
      &:before{
        background-image: url(../assets/left-arrow.png);
      }
      &:hover{
        &:before{
          background-image: url(../assets/left-arrow-white.png);
        }
      }
    }
    .next{
      margin-left: auto;
      padding-right: 40px;
      @media (max-width: 680px) {
        padding-right: 36px;
      }
      &:before{
        right: 10px; left: auto;;
        background-image: url(../assets/right-arrow.png);
      }
      &:hover{
        &:before{
          background-image: url(../assets/right-arrow-white.png);
        }
      }
    }
  }
}
.notFound{
  position: static;
  transform: none;
  padding: 60px 20px 50px;
  border-radius: 10px;
  // border: #eee 1px solid;
  margin: 0 20px;
  text-align: center;
  color: #444;
  @media (max-width: 680px) {
    margin: 0 16px;
  }
  img{
    height: auto; width: 100%;
    max-width: 180px;
    margin-bottom: 30px;
    @media (max-width: 680px) {
      max-width: 140px;
    }
  }
  h2{
    margin: 0 0 8px;
    font-size: 22px;
    line-height: 1;
    font-weight: 400;
    @media (max-width: 680px) {
      font-size: 26px;
    }
  }
  p{
    margin: 0;
    color: #767676;
    font-size: 15px;
  }
}

@keyframes indeterminate {
  0% { left: -35%; right: 100%; }
  60% { left: 100%; right: -90%; }
  100% { left: 100%; right: -90%; }
}
@keyframes indeterminate-short {
  0% { left: -200%; right: 100%; }
  60% { left: 107%; right: -8%; }
  100% { left: 107%; right: -8%; }
}
.loading{
  margin: 20px 20px;
  .progress{
    height: 4px;
    background-color: #bbcee8;
    position: relative;
    overflow: hidden;
    .indeterminate {
      background-color: #5184c6;
      &:before{
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0; left: 0; bottom: 0;
        will-change: left, right;
        animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      }
      &:after {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
      }
    }
  }
}
.totalItem{
  margin: -10px 20px 20px;
  color: #767676;
}
.sectionTitle{
  font-size: 18px;
  color: #767676;
  margin: 6px 40px;
  text-align: left;
  @media (max-width: 680px) {
    margin: 6px 36px;
  }
}

.subCategoryCnt{
  display: flex;
  margin: 0 10px;
  padding: 0;
  flex-wrap: wrap;
  position: relative;
  z-index: 9;
  .subCategoryItem{
    width: 20%;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    margin: 10px 0;
    cursor: pointer;
    display: block;
    color: #444;
    .subCategoryImg{
      height: 12vw;
      background-color: #f5f5f5;
      background-position: center;
      background-size: cover;
      border-radius: 3px;
      margin-bottom: 10px;
      position: relative;
      transition: all .3s ease;
      @media (max-width: 1440px) {
        height: 11vw;
      }
      &.noImg{
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          transition: all .3s ease;
          background-image: url(../assets/directory.png);
          background-size: 64px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .2;
        }
      }
      &:hover{
        background-color: #f5f5fe;
        &:before{
          opacity: .4;
        }
      }
    }
  }
}

.allContentCnt{
  padding: 0 0 20px;
  .allContent{
    margin: 0 20px;
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{}
    .contentItem{
      border-radius: 10px;
      border: #eee 1px solid;
      margin-bottom: 20px;
      padding: 20px;
      cursor: pointer;
      @media (max-width: 680px) {
        padding: 20px 16px;
      }
      h4{
        margin: 0 0 14px;
        font-size: 24px;
        line-height: 1.3;
        // font-family: 'Source Serif Pro', serif;
        font-weight: 400;
        @media (max-width: 680px) {
          font-size: 20px;
          margin: 0 0 10px;
        }
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .labels{
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 4px;
        @media (max-width: 680px) {
          padding-bottom: 7px;
        }
        .label{
          padding: 6px 10px;
          font-size: 13px;
          margin: 0 10px 10px 0;
          background-color: #222;
          color: #fff;
          border-radius: 3px;
          // font-family: 'Inter', sans-serif;
          font-weight: 500;
          &.category{
            background-color: #212E71;
          }
          &.status{
            background-color: #115457;
          }
          &.subjekHukum{
            background-color: #571010;
            display: none;
          }
          @media (max-width: 680px) {
            margin: 0 5px 5px 0;
            font-size: 12px;
          }
        }
      }
      .tags{
        display: flex;
        flex-wrap: wrap;
        .tag{
          cursor: pointer;
          margin: 0 14px 6px 0;
          color: #115457;
          transition: all .3s ease;
          @media (max-width: 680px) {
            margin: 0 12px 2px 0;
            font-size: 15px;
          }
          &:hover{
            color: #369d66;
          }
        }
      }
      .contentInfo{
        position: relative;
        display: flex;
        @media (max-width: 860px) {
          display: block;
        }
        .contentInfoL{
          width: calc(100% - 300px);
          box-sizing: border-box;
          padding-right: 20px;
          @media (max-width: 860px) {
            width: auto;
            padding-right: 0;
          }
          .contentDesc{
            margin: 0 0 14px;
            @media (max-width: 680px) {
              margin: 0 0 10px;
              font-size: 15px;
            }
          }
        }
        .dateCnt{
          width: 300px;
          border-left: #eee 1px solid;
          box-sizing: border-box;
          padding-left: 20px;
          display: flex;
          flex-wrap: wrap;
          @media (max-width: 860px) {
            width: auto;
            margin-top: 8px;
            padding: 0;
            display: block;
            border: none;
          }
          .date{
            display: flex;
            width: 100%;
            padding: 0 0 8px;
            @media (max-width: 860px) {
              padding: 0 0 6px;
            }
            @media (max-width: 680px) {
              font-size: 15px;
            }
            .dateLabel{
              width: 160px;
              @media (max-width: 680px) {
                width: 140px;
              }
            }
          }
        }
      }
    }
  }
}

.copyright{
  text-align: center;
  font-size: 14px;
  color: #767676;
  padding: 30px 0 10px;
}

@keyframes heartAnimation {
  from {
    transform: scale(.4);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes heartAnimation2 {
  from {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}

</style>
